import { render, staticRenderFns } from "./TheLayoutHeader.vue?vue&type=template&id=32b1c64a&scoped=true&"
import script from "./TheLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./TheLayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutHeader.vue?vue&type=style&index=0&id=32b1c64a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1c64a",
  null
  
)

export default component.exports